import { Icon } from "@iconify/react";
import { Colors } from "../../../utils/colors";
import StandardBorderedContainer from "../../Containers/StandardBorderedContainer";

type TriggerSummaryHeaderProps = {
  additionalText: string;
};

// Header section for the trigger summary panel
const TriggerSummaryHeader = (props: TriggerSummaryHeaderProps) => {
  const { additionalText } = props;

  const styles = {
    showcaseBody: {
      paddingInline: 14,
      gap: 14,
    },
  };

  return (
    <div className="AlignedRow" style={styles.showcaseBody}>
      <StandardBorderedContainer
        containerStyles={{
          width: 38,
          height: 38,
          borderRadius: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: Colors.WHITE,
        }}
      >
        <Icon icon={"ion:flash"} height={20} />
      </StandardBorderedContainer>
      <div className="ColumnNormal" style={{ gap: 4, flex: 1 }}>
        <span className="sectionTitle">Trigger</span>
        <span className="smallBodySubtext">
          People enter this automation when this happens.
          {additionalText && ` ${additionalText}`}
        </span>
      </div>
    </div>
  );
};

export default TriggerSummaryHeader;
